/**
 * /admin/ma-carte — Page dédiée "Ma carte de visite" pour l'admin.
 * Utilise le composant réutilisable MaVCardQuickAccess.
 */
import React, { useEffect } from 'react';
import MaVCardQuickAccess from '../../components/MaVCardQuickAccess';

export default function AdminMaCarte() {
  useEffect(() => { document.title = 'Ma carte de visite · Admin'; }, []);
  return <MaVCardQuickAccess />;
}
